import { ReactNode } from 'react';
import { TSortOrder } from './types';
import TranslatedLabel from 'components/TranslatedLabel';
import { CheckboxOptionType, Tooltip } from 'antd';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';

export const DATE_SORT_CONFIG: Array<{
	translationKey: string;
	icon: ReactNode;
	value: TSortOrder;
}> = [
	{ translationKey: 'newest', icon: <ArrowDownOutlined />, value: 'DESC' },
	{ translationKey: 'oldest', icon: <ArrowUpOutlined />, value: 'ASC' },
];

export const DATE_SORT_RADIO_OPTIONS = DATE_SORT_CONFIG.map<CheckboxOptionType<TSortOrder>>(
	({ translationKey, icon, value }) => ({
		value,
		label: (
			<Tooltip
				title={
					<TranslatedLabel
						nameSpace='dispatcher'
						i18nKey={`date_sort_buttons.${translationKey}`}
					/>
				}
			>
				{icon}
			</Tooltip>
		),
	})
);
